import { jsx as _jsx } from "react/jsx-runtime";
import ContentListItem from "../../ContentListItem";
import { DividerItems } from "@ploy-ui/core";
import { Link } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Links from "./Links";
import { usePrefetchResources } from "../usePrefetchResources";
export function LinkListItems(props) {
    const { page = 0, pageSize, emptyMessage } = props;
    let [links] = usePrefetchResources(Links, props, props.placeholder);
    links = links?.slice().sort((a, b) => a.sortOrder - b.sortOrder);
    if (pageSize)
        links = links?.slice((page - 1) * pageSize, page * pageSize);
    if (links?.length === 0) {
        return (_jsx(ContentListItem, { secondary: emptyMessage ?? (_jsx(FormattedMessage, { id: "dploy.dashboard.linklist.empty", defaultMessage: "Ingen lenker" })), hideChevron: true }));
    }
    return (_jsx(DividerItems, { children: links?.map(link => (_jsx(ContentListItem, { button: true, component: Link, href: link.linkUrl, target: "_blank", rel: "noopener noreferrer", primary: link.linkText ?? link.linkUrl, chevronIcon: _jsx(OpenInNewIcon, { fontSize: "small" }) }, link.linkId))) }));
}
//# sourceMappingURL=LinkListItems.js.map